import { parse, stringify } from 'uuid';
export var RecordType;
(function (RecordType) {
    RecordType["ANNOTATION"] = "ANNOTATION";
    RecordType["EXAMPLE"] = "EXAMPLE";
    RecordType["PARAMETER"] = "PARAMETER";
    RecordType["SAMPLE"] = "SAMPLE";
})(RecordType || (RecordType = {}));
export class BaseRecord {
    id;
    type;
    logicalType;
    metadata;
    retracted;
    constructor(id, recordType, logicalType, metadata, retracted) {
        if (retracted != undefined && recordType != RecordType.ANNOTATION) {
            // TODO this could be added to the signature
            throw new TypeError('Retracted field is only accepted for ANNOTATION records');
        }
        this.id = stringify(parse(id));
        this.type = recordType;
        this.logicalType = logicalType;
        this.metadata = metadata || new Map();
        this.retracted = retracted;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFzZVJlY29yZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvdHlwZXMvcmVjb3JkL0Jhc2VSZWNvcmQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLEtBQUssRUFBRSxTQUFTLEVBQUUsTUFBTSxNQUFNLENBQUE7QUFPdkMsTUFBTSxDQUFOLElBQVksVUFLWDtBQUxELFdBQVksVUFBVTtJQUNwQix1Q0FBeUIsQ0FBQTtJQUN6QixpQ0FBbUIsQ0FBQTtJQUNuQixxQ0FBdUIsQ0FBQTtJQUN2QiwrQkFBaUIsQ0FBQTtBQUNuQixDQUFDLEVBTFcsVUFBVSxLQUFWLFVBQVUsUUFLckI7QUFFRCxNQUFNLE9BQWdCLFVBQVU7SUFDOUIsRUFBRSxDQUFRO0lBQ1YsSUFBSSxDQUFZO0lBQ2hCLFdBQVcsQ0FBYztJQUN6QixRQUFRLENBQVU7SUFDbEIsU0FBUyxDQUFhO0lBRXRCLFlBQ0UsRUFBVSxFQUNWLFVBQXNCLEVBQ3RCLFdBQXlCLEVBQ3pCLFFBQW1CLEVBQ25CLFNBQXNCO1FBRXRCLElBQUksU0FBUyxJQUFJLFNBQVMsSUFBSSxVQUFVLElBQUksVUFBVSxDQUFDLFVBQVUsRUFBRSxDQUFDO1lBQ2xFLDRDQUE0QztZQUM1QyxNQUFNLElBQUksU0FBUyxDQUNqQix5REFBeUQsQ0FDMUQsQ0FBQTtRQUNILENBQUM7UUFFRCxJQUFJLENBQUMsRUFBRSxHQUFHLFNBQVMsQ0FBQyxLQUFLLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQTtRQUM5QixJQUFJLENBQUMsSUFBSSxHQUFHLFVBQVUsQ0FBQTtRQUN0QixJQUFJLENBQUMsV0FBVyxHQUFHLFdBQVcsQ0FBQTtRQUM5QixJQUFJLENBQUMsUUFBUSxHQUFHLFFBQVEsSUFBSSxJQUFJLEdBQUcsRUFBRSxDQUFBO1FBQ3JDLElBQUksQ0FBQyxTQUFTLEdBQUcsU0FBUyxDQUFBO0lBQzVCLENBQUM7Q0FDRiJ9